import React from "react";
import CustomButton from "./CustomButton";

const SelectSubjectSearchBar = ({
  searchInput,
  onSearchButtonClick,
  onSearchChange,
}) => {
  return (
    <div className="select_wrapper_card">
      <div className="row">
        <div className="col-xl-12">
          <form>
            <div className="row justify-content-between g-3">
              <div className="col-xl-12">
                <div className="filter-wrapper">
                  <div className="filter-date-blk">
                    <div className="form-block p-relative">
                      <input
                        type="text"
                        className="form-control"
                        id="search"
                        placeholder="Search by field name, crop name"
                        value={searchInput}
                        onChange={onSearchChange}
                        onKeyPress={(e) =>
                          e.key === "Enter" && onSearchButtonClick(e)
                        }
                      />
                      <span className="search-icon" />
                    </div>
                    <div className="filter-action-btn-blk">
                      <CustomButton
                        onClick={onSearchButtonClick}
                        title="Search"
                        className="btn primary-btn"
                      />
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SelectSubjectSearchBar;
